"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
exports.cRemoveColumns = "cRemoveColumns";
exports.cReplaceWithMode = "cReplaceWithMode";
exports.cRemoveRows = "cRemoveRows";
exports.nRemoveColumns = "nRemoveColumns";
exports.nReplaceWithZero = "nReplaceWithZero";
exports.nReplaceWithMean = "nReplaceWithMean";
exports.nReplaceWithMedian = "nReplaceWithMedian";
exports.nReplaceWithPrevValue = "nReplaceWithPrevValue";
exports.nReplaceWithMode = "nReplaceWithMode";
exports.nRemoveRows = "nRemoveRows";
exports.tRemoveColumns = "tRemoveColumns";
exports.tReplaceWithMode = "tReplaceWithMode";
exports.tRemoveRows = "tRemoveRows";
exports.dRemoveColumns = "dRemoveColumns";
exports.dRemoveRows = "dRemoveRows";
exports.read = (value, type, setColumnData, columnData) => {
    switch (type) {
        case exports.cRemoveColumns:
            setColumnData((pre) => (Object.assign({}, pre, { selectedCategoricalRemoveColumns: value, categoricalRemainingColumns: columnData.categoricalRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.cReplaceWithMode:
            setColumnData((pre) => (Object.assign({}, pre, { selectedCategoricalReplaceWithMode: value, categoricalRemainingColumns: columnData.categoricalRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.cRemoveRows:
            setColumnData((pre) => (Object.assign({}, pre, { selectedCategoricalRemoveRows: value, categoricalRemainingColumns: columnData.categoricalRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.nRemoveColumns:
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalRemoveColmns: value, numericalRemainingColumns: columnData.numericalRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.nReplaceWithZero:
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalReplaceWithZero: value, numericalRemainingColumns: columnData.numericalRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.nReplaceWithMean:
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalReplaceWithMean: value, numericalRemainingColumns: columnData.numericalRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.nReplaceWithMedian:
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalReplaceWithMedian: value, numericalRemainingColumns: columnData.numericalRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.nReplaceWithPrevValue:
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalReplaceWithPrevValue: value, numericalRemainingColumns: columnData.numericalRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.nReplaceWithMode:
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalReplaceWithMode: value, numericalRemainingColumns: columnData.numericalRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.nRemoveRows:
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalRemoveRows: value, numericalRemainingColumns: columnData.numericalRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.tRemoveColumns:
            setColumnData((pre) => (Object.assign({}, pre, { selectedTargetRemoveColumns: value, targetRemainingColumns: columnData.targetRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.tRemoveRows:
        case exports.tReplaceWithMode:
            setColumnData((pre) => (Object.assign({}, pre, { selectedTargetReplaceWithMode: value, targetRemainingColumns: columnData.targetRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.tRemoveRows:
            setColumnData((pre) => (Object.assign({}, pre, { selectedTargetRemoveRows: value, targetRemainingColumns: columnData.targetRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.dRemoveColumns:
            setColumnData((pre) => (Object.assign({}, pre, { selectedDateTimeRemoveColumns: value, dateTimeRemainingColumns: columnData.dateTimeRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        case exports.dRemoveRows:
            setColumnData((pre) => (Object.assign({}, pre, { selectedDateTimeRemoveRows: value, dateTimeRemainingColumns: columnData.dateTimeRemainingColumns.filter((r) => r !== value[value.length - 1]) })));
            break;
        default:
            break;
    }
};
exports.remove = (index, type, setColumnData, columnData) => {
    switch (type) {
        case exports.cRemoveColumns:
            const a1 = [...columnData.selectedCategoricalRemoveColumns];
            a1.splice(index, 1);
            const b1 = [...columnData.categoricalRemainingColumns];
            b1.includes(columnData.selectedCategoricalRemoveColumns[index]) ===
                false && b1.push(columnData.selectedCategoricalRemoveColumns[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedCategoricalRemoveColumns: a1, categoricalRemainingColumns: b1 })));
            break;
        case exports.cReplaceWithMode:
            const a2 = [...columnData.selectedCategoricalReplaceWithMode];
            a2.splice(index, 1);
            const b2 = [...columnData.categoricalRemainingColumns];
            b2.includes(columnData.selectedCategoricalReplaceWithMode[index]) ===
                false && b2.push(columnData.selectedCategoricalReplaceWithMode[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedCategoricalReplaceWithMode: a2, categoricalRemainingColumns: b2 })));
            break;
        case exports.cRemoveRows:
            const a3 = [...columnData.selectedCategoricalRemoveRows];
            a3.splice(index, 1);
            const b3 = [...columnData.categoricalRemainingColumns];
            b3.includes(columnData.selectedCategoricalRemoveRows[index]) === false &&
                b3.push(columnData.selectedCategoricalRemoveRows[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedCategoricalRemoveRows: a3, categoricalRemainingColumns: b3 })));
            break;
        case exports.nRemoveColumns:
            const a4 = [...columnData.selectedNumericalRemoveColmns];
            a4.splice(index, 1);
            const b4 = [...columnData.numericalRemainingColumns];
            b4.includes(columnData.selectedNumericalRemoveColmns[index]) === false &&
                b4.push(columnData.selectedNumericalRemoveColmns[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalRemoveColmns: a4, numericalRemainingColumns: b4 })));
            break;
        case exports.nReplaceWithZero:
            const a5 = [...columnData.selectedNumericalReplaceWithZero];
            a5.splice(index, 1);
            const b5 = [...columnData.numericalRemainingColumns];
            b5.includes(columnData.selectedNumericalReplaceWithZero[index]) ===
                false && b5.push(columnData.selectedNumericalReplaceWithZero[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalReplaceWithZero: a5, numericalRemainingColumns: b5 })));
            break;
        case exports.nReplaceWithMean:
            const a6 = [...columnData.selectedNumericalReplaceWithMean];
            a6.splice(index, 1);
            const b6 = [...columnData.numericalRemainingColumns];
            b6.includes(columnData.selectedNumericalReplaceWithMean[index]) ===
                false && b6.push(columnData.selectedNumericalReplaceWithMean[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalReplaceWithMean: a6, numericalRemainingColumns: b6 })));
            break;
        case exports.nReplaceWithMedian:
            const a7 = [...columnData.selectedNumericalReplaceWithMedian];
            a7.splice(index, 1);
            const b7 = [...columnData.numericalRemainingColumns];
            b7.includes(columnData.selectedNumericalReplaceWithMedian[index]) ===
                false && b7.push(columnData.selectedNumericalReplaceWithMedian[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalReplaceWithMedian: a7, numericalRemainingColumns: b7 })));
            break;
        case exports.nReplaceWithPrevValue:
            const a15 = [...columnData.selectedNumericalReplaceWithPrevValue];
            a15.splice(index, 1);
            const b15 = [...columnData.numericalRemainingColumns];
            b15.includes(columnData.selectedNumericalReplaceWithPrevValue[index]) ===
                false && b15.push(columnData.selectedNumericalReplaceWithPrevValue[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalReplaceWithPrevValue: a15, numericalRemainingColumns: b15 })));
            break;
        case exports.nReplaceWithMode:
            const a8 = [...columnData.selectedNumericalReplaceWithMode];
            a8.splice(index, 1);
            const b8 = [...columnData.numericalRemainingColumns];
            b8.includes(columnData.selectedNumericalReplaceWithMode[index]) ===
                false && b8.push(columnData.selectedNumericalReplaceWithMode[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalReplaceWithMode: a8, numericalRemainingColumns: b8 })));
            break;
        case exports.nRemoveRows:
            const a9 = [...columnData.selectedNumericalRemoveRows];
            a9.splice(index, 1);
            const b9 = [...columnData.numericalRemainingColumns];
            b9.includes(columnData.selectedNumericalRemoveRows[index]) === false &&
                b9.push(columnData.selectedNumericalRemoveRows[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedNumericalRemoveRows: a9, numericalRemainingColumns: b9 })));
            break;
        case exports.tRemoveColumns:
            const a10 = [...columnData.selectedTargetRemoveColumns];
            a10.splice(index, 1);
            const b10 = [...columnData.targetRemainingColumns];
            b10.includes(columnData.selectedTargetRemoveColumns[index]) === false &&
                b10.push(columnData.selectedTargetRemoveColumns[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedTargetRemoveColumns: a10, targetRemainingColumns: b10 })));
            break;
        case exports.tReplaceWithMode:
            const a11 = [...columnData.selectedTargetReplaceWithMode];
            a10.splice(index, 1);
            const b11 = [...columnData.targetRemainingColumns];
            b10.includes(columnData.selectedTargetReplaceWithMode[index]) === false &&
                b10.push(columnData.selectedTargetReplaceWithMode[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedTargetReplaceWithMode: a11, targetRemainingColumns: b11 })));
            break;
        case exports.tRemoveRows:
            const a12 = [...columnData.selectedTargetRemoveRows];
            a11.splice(index, 1);
            const b12 = [...columnData.targetRemainingColumns];
            b11.includes(columnData.selectedTargetRemoveRows[index]) === false &&
                b11.push(columnData.selectedTargetRemoveRows[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedTargetRemoveRows: a12, targetRemainingColumns: b12 })));
            break;
        case exports.dRemoveColumns:
            const a13 = [...columnData.selectedDateTimeRemoveColumns];
            a13.splice(index, 1);
            const b13 = [...columnData.dateTimeRemainingColumns];
            b13.includes(columnData.selectedDateTimeRemoveColumns[index]) === false &&
                b13.push(columnData.selectedDateTimeRemoveColumns[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedDateTimeRemoveColumns: a13, dateTimeRemainingColumns: b13 })));
            break;
        case exports.dRemoveRows:
            const a14 = [...columnData.selectedDateTimeRemoveRows];
            a12.splice(index, 1);
            const b14 = [...columnData.dateTimeRemainingColumns];
            b12.includes(columnData.selectedDateTimeRemoveRows[index]) === false &&
                b12.push(columnData.selectedDateTimeRemoveRows[index]);
            setColumnData((pre) => (Object.assign({}, pre, { selectedDateTimeRemoveRows: a14, dateTimeRemainingColumns: b14 })));
            break;
        default:
            break;
    }
};
//# sourceMappingURL=column-selection.js.map